<template>
  <section class="mt-10">
    <div class="level">
      <div class="level-left">
        <div class="level-item mr-20">
          <b-field>
            <b-autocomplete
              v-model="contact"
              placeholder="Recherche"
              icon="magnify"
              clearable
              @select="option => selected = option">
              <template slot="empty">
                {{$t('detailClient.ongletContacts.aucunResultat')}}
              </template>
            </b-autocomplete>
          </b-field>
        </div>
      </div>
      <div class="level-right">
        <b-button type="is-primary" 
          class="has-text-weight-bold"
          @click="ajoutContactActive = true">
          {{$t('detailClient.ongletContacts.btnAjoutContact')}}
        </b-button>
      </div>
    </div>
    <div class="columns is-12 is-multiline">
      <div class="column is-4"
      v-for="(contact, i) in listesContact"
      :key="i">
        <div class="media media-align-center has-background-white">
          <div class="media-left ma-10">
            <avatar :username="contact.prenom[0] + ' ' + contact.nom[0]"
                    :rounded="false">
            </avatar>
          </div>
          <div class="media-content ma-10">
            <div class="content">
              <div class="columns is-12 is-vcentered">
                <div class="column is-6">
                  <p class="is-size-14px has-text-weight-bold has-text-gird-1 mb-0">
                    {{contact.prenom}} {{contact.nom}}
                  </p>
                  <p class="is-size-7 has-text-default">
                    {{contact.fonction}}
                  </p>
                </div>
                <div class="column is-6">
                  <p class="is-size-7 has-text-default mb-0">
                    {{contact.email}}
                  </p>
                  <p class="is-size-7 has-text-default">
                    {{contact.telephone}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="media-right">
            <b-dropdown
              position="is-bottom-left"
              aria-role="list">
              <a
                class="navbar-item"
                slot="trigger"
                role="button">
                <b-icon custom-class="icon-color" icon="dots-vertical"></b-icon>
              </a>
              <b-dropdown-item
                aria-role="listitem"
                @click="modifierContact(contact)">
                {{$t('creerClient.modifierContact')}}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
      <div class="column ma-10 card-contact" v-if="!listesContact.length">
          <div class="media media-align-center">
            <div class="media-content">
              <div class="content has-text-centered is-size-7">
                {{$t('creerClient.aucunContact')}}
              </div>
            </div>
          </div>
      </div>
    </div>
    <contact v-if="ajoutContactActive || modifierContactActive"
      @close="refreshContact()"
      :oneContact="oneContact"
      :isModification="modifierContactActive"/>
  </section>
</template>

<script>
import Avatar from 'vue-avatar';
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as types from '@/store/modules/contacts-mutation-type';
import { getContactClient } from '@/api/contacts/index.js';
import gestionErreur from '@/services/general/gestionErreur';
import Contact from './../contact.vue';

const Contacts = createNamespacedHelpers('contacts');

export default {
  components: {
    Avatar,
    Contact,
  },
  data: () => ({
    contact: '',
    listesContact: {},
    ajoutContactActive: false,
    modifierContactActive: false,
    oneContact: true,
  }),
  methods: {
    ...Contacts.mapMutations({
      setContact: types.SET_CONTACT,
      resetContact: types.RESET_CONTACT,
    }),
    modifierContact(contact) {
      this.setContact(cloneDeep(contact));
      this.modifierContactActive = true;
    },
    async getContact() {
      try {
        this.listesContact = (await getContactClient(this.$route.params.id)).data;
      } catch (error) {
        gestionErreur(`Erreur lors de la récupération des contacts du client id: ${this.$route.params.id}`, error);
      }
    },
    async refreshContact() {
      this.ajoutContactActive = false;
      this.modifierContactActive = false;
      this.resetContact();
      const loadingComponent = this.$buefy.loading.open({ container: null });
      await this.getContact();
      loadingComponent.close();
    }
  },
  mounted() {
    this.getContact();
  }
};
</script>

<style>

</style>